import type { SVGProps } from 'react';
const SvgSquareParking = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.857 5.143a.716.716 0 0 0-.714.714v14.286c0 .393.321.714.714.714h14.286a.716.716 0 0 0 .714-.714V5.857a.716.716 0 0 0-.714-.714zM3 5.857A2.86 2.86 0 0 1 5.857 3h14.286A2.86 2.86 0 0 1 23 5.857v14.286A2.86 2.86 0 0 1 20.143 23H5.857A2.86 2.86 0 0 1 3 20.143zm7.857 7.857h2.857a2.143 2.143 0 0 0 0-4.285h-2.857zm2.857 2.143h-2.857v1.786c0 .594-.477 1.071-1.071 1.071a1.07 1.07 0 0 1-1.072-1.071V8.714c0-.79.639-1.428 1.429-1.428h3.571a4.287 4.287 0 0 1 0 8.571"
    />
  </svg>
);
export default SvgSquareParking;
